function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from "react";
import PropTypes from "prop-types";
import { jsx as ___EmotionJSX } from "@emotion/core";

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "13o7eu2",
  styles: "display:block;"
} : {
  name: "13o7eu2",
  styles: "display:block;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pY29ucy9jYWxjdWxhdG9yLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1NIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9pY29ucy9jYWxjdWxhdG9yLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tIFwicHJvcC10eXBlc1wiO1xuXG5mdW5jdGlvbiBDYWxjdWxhdG9yKHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTI1IDFhMiAyIDAgMCAxIDIgMnYyNmEyIDIgMCAwIDEtMiAySDdhMiAyIDAgMCAxLTItMlYzYTIgMiAwIDAgMSAyLTJoMTh6TTEyIDI2SDd2MmExIDEgMCAwIDAgLjg4My45OTNMOCAyOWg0di0zem02IDBoLTR2M2g0di0zem03LTVoLTV2OGg0YTEgMSAwIDAgMCAuOTkzLS44ODNMMjUgMjh2LTd6bS03IDBoLTR2M2g0di0zem0tNiAwSDd2M2g1di0zem0wLTVIN3YzaDV2LTN6bTYgMGgtNHYzaDR2LTN6bTcgMGgtNXYzaDV2LTN6bS0xMy01SDd2M2g1di0zem02IDBoLTR2M2g0di0zem03IDBoLTV2M2g1di0zem0tMS04SDhhMSAxIDAgMCAwLS45OTMuODgzTDcgNHY1aDE4VjRhMSAxIDAgMCAwLTEtMXptLTIgMWExIDEgMCAwIDEgMSAxdjJhMSAxIDAgMCAxLTEgMWgtMWExIDEgMCAwIDEtMS0xVjVhMSAxIDAgMCAxIDEtMWgxem0wIDFoLTF2MmgxVjV6XCJcbiAgICAgICAgZmlsbD17cHJpbWFyeUNvbG9yfVxuICAgICAgLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn1cblxuQ2FsY3VsYXRvci5wcm9wVHlwZXMgPSB7XG4gIHNpemU6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgcHJpbWFyeUNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHRlc3RJZDogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IENhbGN1bGF0b3I7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function Calculator(_ref) {
  var size = _ref.size,
      primaryColor = _ref.primaryColor,
      testId = _ref.testId;
  return ___EmotionJSX("svg", {
    css: _ref2,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M25 1a2 2 0 0 1 2 2v26a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h18zM12 26H7v2a1 1 0 0 0 .883.993L8 29h4v-3zm6 0h-4v3h4v-3zm7-5h-5v8h4a1 1 0 0 0 .993-.883L25 28v-7zm-7 0h-4v3h4v-3zm-6 0H7v3h5v-3zm0-5H7v3h5v-3zm6 0h-4v3h4v-3zm7 0h-5v3h5v-3zm-13-5H7v3h5v-3zm6 0h-4v3h4v-3zm7 0h-5v3h5v-3zm-1-8H8a1 1 0 0 0-.993.883L7 4v5h18V4a1 1 0 0 0-1-1zm-2 1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h1zm0 1h-1v2h1V5z",
    fill: primaryColor
  }));
}

Calculator.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  testId: PropTypes.string
};
export default Calculator;